import { render, staticRenderFns } from "./PostTip.vue?vue&type=template&id=1297ff0c&scoped=true&"
import script from "./PostTip.vue?vue&type=script&lang=js&"
export * from "./PostTip.vue?vue&type=script&lang=js&"
import style0 from "./PostTip.vue?vue&type=style&index=0&id=1297ff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1297ff0c",
  null
  
)

export default component.exports